<div class="card menu-card-hub">
  <div class="card-body menu-card-body">
    <h5 class="card-title">

      <span class="card-header-icon">      <daz-icon [name]="icon" [size]="'24px'"
                                                     [color]="'var(--hubtiger-secondary)'"></daz-icon></span>
      <!--    //  <span class="card-header-icon {{icon}}"></span>-->
      <span class="card-header-text"> {{header | translate }}</span>

    </h5>
    <ul class=" card-items list-group list-group-flush">
      <li class="list-group-item card-list-item {{navigationItem.classId}}" [ngClass]="{'disabled-option': navigationItem.disabled}"
          *ngFor="let navigationItem of navigationItems"
          [routerLink]="['/'+navigationItem.path]">
        <a class="card-menu-link"
           [ngClass]="{'disabled-option': navigationItem.disabled}">
          {{navigationItem.title}}
        </a>
        <span
          class="card-link-icon fa fa-arrow-right">
        </span>
      </li>
    </ul>
  </div>
</div>
